import { API_ROOT, endPoints } from "../appSettings";
import { adalApiFetch, authProvider } from "../authProvider";

export const GET_PERMISSIONS = "GET_PERMISSIONS";

export function getPermissions(email) {
  const url = `${API_ROOT}${endPoints.user}/${email}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return async (dispatch) => {
    const response = await adalApiFetch(fetch, url, options, dispatch);
    const json = await response.json();

    if (!response.ok) {
      return Promise.reject(json);
    }

    return dispatch({
      type: GET_PERMISSIONS,
      isSuccess: true,
      payload: json,
    });
  };
}

export const refreshPermissions = async (token, dispatch) => {
  const tokenId = await authProvider.getIdToken();
  const url = `${API_ROOT}${endPoints.user}/${tokenId.idToken.preferredName}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token.accessToken}`,
    },
  };

  const response = await fetch(url, options);

  const json = await response.json();

  if (!response.ok) {
    return Promise.reject(json);
  }
  return dispatch({
    type: GET_PERMISSIONS,
    isSuccess: true,
    payload: json,
  });
};
